/**
 * WalkAndPunch API
 * This is the WalkAndPunch API
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type PunchDetailsTab = 1 | 2 | 3 | 4;

export const PunchDetailsTab = {
    NUMBER_1: 1 as PunchDetailsTab,
    NUMBER_2: 2 as PunchDetailsTab,
    NUMBER_3: 3 as PunchDetailsTab,
    NUMBER_4: 4 as PunchDetailsTab
};